import type { StandardNoteNameWithOctave } from '@tunasong/schemas'

export type Tuning = Record<number, StandardNoteNameWithOctave>

/** @see https://en.wikipedia.org/wiki/Guitar_tunings */

export const GuitarTunings: Record<string, Tuning> = {
  normal: {
    1: 'E4',
    2: 'B3',
    3: 'G3',
    4: 'D3',
    5: 'A2',
    6: 'E2',
  },
  dropd: {
    1: 'E4',
    2: 'B3',
    3: 'G3',
    4: 'D3',
    5: 'A2',
    6: 'D2',
  },
}

/** Standard 4-string bass tunings */
export const BassTunings: Record<string, Tuning> = {
  normal: {
    1: 'G2', // High G string
    2: 'D2', // D string
    3: 'A1', // A string
    4: 'E1', // Low E string
  },
  dropd: {
    1: 'G2',
    2: 'D2',
    3: 'A1',
    4: 'D1', // Dropped D tuning
  },
}
